/**
 * Class-name join. Deliberately not `tailwind-merge`: our components compose
 * class strings from variant maps that do not overlap, and a caller who passes
 * `className` is expected to know it wins by source order.
 */
export function cx(...parts: readonly (string | false | null | undefined)[]): string {
  return parts
    .filter((part): part is string => typeof part === 'string' && part.length > 0)
    .join(' ');
}
